{
  "refinement-extensions.allApps": "All applications",
  "refinement-extensions.management": "Application settings",
  "refinement-extensions.deviceTracking.tab.devices": "Devices",
  "refinement-extensions.deviceTracking.tab.usage": "Usage",
  "refinement-extensions.slot.music.practice": "Music practice",
  "refinement-extensions.slot.lessons.sessions": "Lesson sessions",
  "refinement-extensions.slot.cycling.rides": "Bicycle rides",
  "refinement-extensions.slot.device_tracking.usage": "Application usage summaries",
  "refinement-extensions.role.music.instrument": "Instrument",
  "refinement-extensions.role.duration": "Duration",
  "refinement-extensions.role.music.assessment": "Assessment",
  "refinement-extensions.role.lessons.course": "Course",
  "refinement-extensions.role.lessons.title": "Session",
  "refinement-extensions.role.lessons.transcript": "Lesson transcript",
  "refinement-extensions.role.cycling.distance": "Distance",
  "refinement-extensions.role.cycling.comment": "Description",
  "refinement-extensions.role.tracking.application": "Application",
  "refinement-extensions.type.short_text": "Short text",
  "refinement-extensions.type.long_text": "Long text",
  "refinement-extensions.type.duration": "Duration",
  "refinement-extensions.type.measurement": "Measurement",
  "refinement-extensions.v2.open": "Explore data-only packs",
  "refinement-extensions.v2.hide": "Hide data-only packs",
  "refinement-extensions.v2.title": "Data-only capability packs",
  "refinement-extensions.v2.description": "Add a coherent Life setup without installing executable code. Every structure, permission and immutable version is reviewed before installation.",
  "refinement-extensions.v2.author.open": "Add package document",
  "refinement-extensions.v2.author.close": "Close package editor",
  "refinement-extensions.v2.author.document": "Closed package JSON",
  "refinement-extensions.v2.author.hint": "Only the bounded Extensions v2 grammar is accepted. Code, HTML, prompts, network fetches and executable expressions are rejected.",
  "refinement-extensions.v2.author.assistant": "This draft came from an assistant",
  "refinement-extensions.v2.author.publish": "Publish this immutable version after validation",
  "refinement-extensions.v2.author.validate": "Validate safely",
  "refinement-extensions.v2.author.save": "Save package version",
  "refinement-extensions.v2.author.valid": "Valid immutable fingerprint: {{fingerprint}}",
  "refinement-extensions.v2.provenance.assistant": "Reviewed assistant draft",
  "refinement-extensions.v2.provenance.owner": "Owner-authored",
  "refinement-extensions.v2.error.noUpgradeTarget": "No upgrade target is available.",
  "refinement-extensions.v2.error.noUpgradePreview": "Preview the upgrade before applying it.",
  "refinement-extensions.v2.error.noRollbackReceipt": "No rollback receipt is available.",
  "refinement-extensions.v2.error.noUninstallPreview": "Preview the uninstall before applying it.",
  "refinement-extensions.v2.error.validateFirst": "Validate the package document first.",
  "refinement-extensions.v2.loadError": "Capability packs could not be loaded.",
  "refinement-extensions.v2.drafts": "Validated package drafts",
  "refinement-extensions.v2.publishDraft": "Publish immutable version",
  "refinement-extensions.v2.updateAvailable": "Update available",
  "refinement-extensions.v2.installed": "Installed",
  "refinement-extensions.v2.available": "Available",
  "refinement-extensions.v2.parts": "parts",
  "refinement-extensions.v2.manage": "Manage",
  "refinement-extensions.v2.review": "Review installation",
  "refinement-extensions.v2.empty": "No data-only packs yet",
  "refinement-extensions.v2.emptyDescription": "Add a validated package document or return when catalogue packs are available.",
  "refinement-extensions.v2.reviewDescription": "Review the exact immutable version, authority and structures before changing your account.",
  "refinement-extensions.v2.source": "Source and trust",
  "refinement-extensions.v2.sensitivity": "Sensitivity",
  "refinement-extensions.v2.fingerprint": "Immutable fingerprint",
  "refinement-extensions.v2.dataEgress": "Data egress",
  "refinement-extensions.v2.noEgress": "None",
  "refinement-extensions.v2.version": "Version",
  "refinement-extensions.v2.structures": "Structures and metadata",
  "refinement-extensions.v2.capabilities": "Granted capabilities",
  "refinement-extensions.v2.scopes": "Granted account scopes",
  "refinement-extensions.v2.preview": "Preview exact installation",
  "refinement-extensions.v2.previewReady": "Signed preview ready",
  "refinement-extensions.v2.consent": "I reviewed this fingerprint, authority and the structures that will be created or bound.",
  "refinement-extensions.v2.install": "Install this exact version",
  "refinement-extensions.v2.activeExact": "Version {{version}} is active with its reviewed grants.",
  "refinement-extensions.v2.updateTitle": "Version change",
  "refinement-extensions.v2.previewUpdate": "Check compatibility",
  "refinement-extensions.v2.updateConsent": "I approve the listed authority and data changes.",
  "refinement-extensions.v2.applyUpdate": "Apply exact update",
  "refinement-extensions.v2.rollback": "Roll back",
  "refinement-extensions.v2.uninstallTitle": "Uninstall package",
  "refinement-extensions.v2.retainExplanation": "The package and grants will be removed. Your Life areas, schemas and records remain intact by default.",
  "refinement-extensions.v2.archiveExplanation": "Package-created areas will be archived after a separate signed preview. Records remain recoverable; nothing is silently purged.",
  "refinement-extensions.v2.archiveData": "Also archive package-created areas",
  "refinement-extensions.v2.previewUninstall": "Preview uninstall",
  "refinement-extensions.v2.archiveConsent": "I approve archiving the listed package-created areas.",
  "refinement-extensions.v2.uninstall": "Uninstall",
  "refinement-extensions.v2.surfaces.title": "Installed package tools",
  "refinement-extensions.v2.surfaces.description": "These safe workspace tools are resolved from active data-only packages and open only built-in Life surfaces.",
  "refinement-extensions.v2.surfaces.error": "Installed package tools could not be loaded.",
  "refinement-extensions.v2.surfaces.openTable": "Open table",
  "refinement-extensions.v2.surfaces.openCards": "Open cards",
  "refinement-extensions.v2.surfaces.openTimeline": "Open timeline",
  "refinement-extensions.v2.surfaces.capture": "Add record",
  "refinement-extensions.v2.surfaces.renderer.record_table": "Record table",
  "refinement-extensions.v2.surfaces.renderer.quick_capture": "Quick capture",
  "refinement-extensions.v2.surfaces.renderer.summary_cards": "Summary cards",
  "refinement-extensions.v2.surfaces.renderer.timeline": "Timeline"
}
